import React, { useContext } from 'react';
import cx from 'classnames';

import { StoreContext } from 'store';
import { Badges } from './Badges';
import { PaymentButton } from './PaymentButton';
import { Text } from 'components/Text';

import { generateItemTitleAnsSubtitle, generateSubtitleColor } from './utils';

import './Item.scss';
import { shopApi } from 'api';

interface RegularItemProps {
  item: shopApi.Item;
  size?: 'm' | 's';
  onPaymentClick?: (event: React.MouseEvent) => void;
  onItemClick?: (item: shopApi.Item) => void;
}

export const RegularItem: React.FC<RegularItemProps> = ({
  item,
  size = 'm',
  onPaymentClick = () => undefined,
  onItemClick = () => undefined,
}) => {
  const { translation: t } = useContext(StoreContext);

  const { title, subtitle } = generateItemTitleAnsSubtitle(item.name, t);

  return (
    <div
      className={cx('item', {
        'item-small': size === 's',
      })}
      onClick={() => onItemClick(item)}
    >
      <Text.HeaderS
        className={cx('item__item-name', {
          'item__item-name-small': size === 's',
        })}
      >
        {title}
      </Text.HeaderS>
      {subtitle && (
        <Text.CapsM
          className="item__item-subtitle"
          style={{
            color: generateSubtitleColor(item.name),
          }}
        >
          {subtitle}
        </Text.CapsM>
      )}
      <div className={cx('item__image', { 'item__image-small': size === 's' })}>
        <img src={item.image_url} alt={item?.name} />
      </div>
      <Badges item={item} />
      <div className="item__details">
        <PaymentButton
          item={item}
          onPaymentClick={event => {
            event.stopPropagation();
            onPaymentClick(event);
          }}
        />
      </div>
      <div
        className={cx('item__available', { 'item__available-small': size === 's' })}
      />
    </div>
  );
};
